// tools and component for date picker
import dayjs from 'dayjs';

import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';

//data:
import shortNamesList from '../../database/articles_short_names.json'
import { appURL } from '../../config/api-config';

//import fr from 'dayjs/locale/fr';
const fr = require('dayjs/locale/fr')
dayjs.locale(fr);

console.log(fr);

const weekday = require('dayjs/plugin/weekday')
dayjs.extend(weekday)


function BlocContratSemaine({ contrat, dateRef }) {

    console.log(contrat.Client.nom, dayjs(contrat.date1).diff(dayjs(dateRef).weekday(0).subtract(1, "day"), "day"));

    let aCommence = dayjs(dateRef.weekday(0)).isAfter(dayjs(contrat.date1), "day");
    let toContinue = dayjs(dateRef.weekday(6)).isBefore(dayjs(contrat.date2), "day");
    let laClasse = "bloc-contrat ";

    let deb = 0;
    let debHeures = 0;
    let dureeJours = 7;
    let dureeHeures = 13;

    if (aCommence === true) {
        if (toContinue === true) {
            dureeHeures = 0;
        }
        else {
            dureeJours = dayjs(contrat.date2).diff(dayjs(dateRef.weekday(0).subtract(1, "day")), "day");
            dureeHeures = contrat.h2 - 8;
            laClasse += " bloc-ended ";
        }

    }
    else { //pas commencé
        deb = dayjs(contrat.date1).diff(dayjs(dateRef.weekday(0).subtract(1, "day")), "day");
        debHeures = contrat.h1 - 9 + 1;
        //console.log(contrat.ref_contrat, dayjs(contrat.date1).diff(dayjs(dateRef), "day"));
        laClasse += " bloc-started ";

        if (toContinue === true) {
            dureeJours = dayjs(dateRef.weekday(6)).diff(dayjs(contrat.date1), "day");
        }
        else {
            dureeJours = dayjs(contrat.date2).diff(dayjs(contrat.date1), "day");
            dureeHeures = contrat.h2 - 9 + 1;
            laClasse += " bloc-ended ";
        }

    }

    let myStyle = {
        width: `${(800 / 7) * dureeJours - (800 / 7 / 13) * debHeures + (800 / 7 / 13) * dureeHeures}px`,
        transform: `translateX(${(800 / 7) * deb + (800 / 7 / 13) * debHeures}px)`
    }

    if (contrat.retour === true) {
        laClasse += " bloc-returned ";
    } else {
        if (contrat.garantie.length > 0) {//resa commence
            laClasse += " bloc-ride ";
        }
        else { // resa en attente
            if (contrat.livraison === true) {//resa commence
                laClasse += " bloc-livraison ";
            }
            else {
                if (contrat.resa === true) {//resa commence
                    laClasse += " bloc-resa ";
                } else {
                    laClasse += " bloc-surplace ";
                }

            }

        }


    }

    let classNom = "ligne-contrat-nom ";
    switch (contrat.spot_id) {
        case 1:
            classNom += " nom-moutchic "
            break;
        case 2:
            classNom += " nom-atelier "
            break;
        case 3:
            classNom += " nom-goelia "
            break;
        case 4:
            classNom += " nom-tedey "
            break;
        case 5:
            classNom += " nom-bernos "
            break;
        case 99:
            classNom += " nom-livraison "
            break;

        default:
            classNom += " "
        // code block
    }



    return (
        <div className="ligne-contrat">
            <div className={classNom}>
                <p className={contrat.resa === true ? "nom-resa" : " "}>{contrat.Client.nom} {contrat.Client.prenom}</p>
            </div>
            <div className="ligne-contrat-semaine">
                <span></span>
                <span></span>
                <span></span>
                <span></span>
                <span></span>
                <span></span>
                <span></span>
                <div style={myStyle} className={laClasse}>
                    {/* <p>{contrat.date1}-{contrat.date2} / {contrat.h1}-{contrat.h2}</p> */}
                    <div className="bloc-contrat-infos">{contrat.ContratArticles.map((art) => (
                        <p>
                            <span
                                style={{
                                    backgroundColor: shortNamesList.find((a) => a.id_article === art.article_id).bgcolor,
                                    color: shortNamesList.find((a) => a.id_article === art.article_id).color
                                }}
                            >{art.qte}
                            </span>
                            {shortNamesList.find((a) => a.id_article === art.article_id).label}
                        </p>
                    ))}</div>
                </div>
            </div>
        </div>
    );
}

export default BlocContratSemaine